import { Tabs, Card, Row, Col, Table, Button, Tag, Form, Modal, Skeleton, Input, DatePicker, Select, Upload, Image, AutoComplete, Dropdown, Menu } from "antd";

import { useEffect, useState } from "react";
import {
    SearchOutlined, SettingOutlined, LockOutlined, MenuOutlined, UnlockOutlined, PlusOutlined, EditOutlined, ContactsOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import swal from "sweetalert";
import moment from "moment";
import axiosClient from "../../api/axios";

import uploadImage from "../../api/upload";
const { Option } = Select
const AdminPage = () => {
    // upload image
    const [roleStatus, setRoleStatus] = useState('')
    const [fileList, setFileList] = useState([{}]);
    const [previewImage, setPreviewImage] = useState("");
    const [previewVisible, setPreviewVisible] = useState(false);
    //  data login
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('Role')
    const database = localStorage.getItem('DatabaseName');
    const IDAccount = localStorage.getItem('ID');
    const cancelUpload = () => {
        setPreviewVisible(false);
    };
    const selectRole = (value) => {
        setRoleStatus(value)
    }
    const previewUpload = async (file) => {
        setPreviewImage(fileList[1].response.url);
        setPreviewVisible(true);
    };
    const fillurl = (arrayurl) => {
        // chèn link url hình ảnh
        formAccount.setFieldsValue({
            Image: arrayurl
        })
    };

    const LockAccount = (record) => {
        if (record.Active === true) {
            // khóa tài khoản
            swal({
                title: "Bạn có muốn khóa tài khoản này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Accounts/LockAccount`, {
                            "ID": record.ID,
                            "Role": record.Role,
                            "UserName": record.UserName,
                            "FullName": record.FullName,
                            "Password": record.Password,
                            "Phone": record.Phone,
                            "Email": record.Email,
                            "Image": record.Image,
                            "Active": false,
                            "DatabaseName": record.DatabaseName,
                            "SecurityCode": record.SecurityCode,
                            "ExpirationDate": record.ExpirationDate
                        }, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Khóa thành công", {
                                    icon: 'success'
                                });
                                loadDataAccount();
                                setLoading(false)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
        else {
            axiosClient.post(`/Accounts/UnLockAccount`, record, { headers: header }).then(res => {
                if (res.status === 200) {
                    swal("Mở khóa thành công", {
                        icon: 'success'
                    });
                    loadDataAccount();
                    setLoading(false)
                }
            })
        }
    }
    const menuAccount = (record) => {
        return (
            <Menu>
                <Menu.Item onClick={(e) => showModalPartner(record.ID)} key="0">
                    <h3 ><EditOutlined /> Sửa</h3>
                </Menu.Item>
                <Menu.Item onClick={(e) => handleDelete(record)} key="1">
                    <h3 ><DeleteOutlined /> Xóa</h3>
                </Menu.Item>
                <Menu.Item onClick={(e) => LockAccount(record)} key="2">
                    {record.Active === true ? <h3 ><LockOutlined /> Khóa tài khoản</h3> : <h3><UnlockOutlined />Mở khóa tài khoản</h3>}
                </Menu.Item>
            </Menu>
        )
    }

    const changeUpload = async ({ fileList }) => {
        setFileList(fileList);
        const dataImage = fileList.map(r => r.name);
        const resultURL = dataImage.join(";");
        fillurl(resultURL)
    };
    // header
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    //data
    const [dataAccount, setDataAccount] = useState([]);
    const [dataPartners, setDataPartners] = useState([])
    const user = {
        "ID": localStorage.getItem('ID'),
        "Role": localStorage.getItem('Role'),
        "UserName": localStorage.getItem('UserName'),
        "FullName": localStorage.getItem('FullName'),
        "Password": localStorage.getItem('Password'),
        "Phone": localStorage.getItem('Phone'),
        "Email": localStorage.getItem('Email'),
        "Image": localStorage.getItem('Image'),
        "Active": true,
        "DatabaseName": localStorage.getItem('DatabaseName'),
        "SecurityCode": localStorage.getItem('SecurityCode'),
        "ExpirationDate": localStorage.getItem('ExpirationDate')
    }
    // form
    const [formAccount] = Form.useForm();
    const [formFilterAccount] = Form.useForm();
    // state
    const [loading, setLoading] = useState(false);
    const [openModalAccount, setOpenModalAccount] = useState(false);
    const [statusModalAccount, setStatusModalAccount] = useState(false);
    // functions
    const loadDataAccount = () => {
        axiosClient.post('/Accounts/SubGetAccountsAll', user, {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataAccount(res.data);
            }
        })
    }
    // search filter
    const [searchResult, setSearchResult] = useState("");
    const suggestionSearch = (value) => {
        let res = "";
        if (!value) {
            res = "";
        } else {
            res = value;
        }
        setSearchResult(res);
    };
    const toDataURL = url => fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
        }))
    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const LoadDataPartners = () => {
        axiosClient.post('/Partners/GetPartnersAll', '', { headers: header }).then(res => {
            setDataPartners(res.data)
        })
    }
    useEffect(() => {
        LoadDataPartners()
        loadDataAccount();
    }, [])
    const columnsAccount = [
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    <SettingOutlined />
                </div>
            ),
            width: 90,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        <Dropdown
                            overlay={menuAccount(record)}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <div style={{ textAlign: 'center' }}>
                                <Button type="text"><MenuOutlined style={{ color: '#2db7f5' }} /></Button>
                            </div>
                        </Dropdown>

                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Tên đăng nhập
            </div>,
            dataIndex: 'UserName',
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        {record.UserName}

                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Họ tên
            </div>,
            dataIndex: 'FullName',
            width: 200,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        {record.FullName}

                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Email
            </div>,
            dataIndex: 'Email',
            width: 200,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        {record.Email}

                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Số điện thoại
            </div>,
            dataIndex: 'Phone',
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        {record.Phone}

                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Quyền
            </div>,
            dataIndex: 'Role',
            width: 100,
            render: (text, record) => (
                <div>
                    <Row style={{ textAlign: 'center', fontSize: 12 }}>
                        <Col span={24}>
                            <p>{record.Role}</p>
                        </Col>
                    </Row>
                </div>

            ),
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Cơ sở dữ liệu
            </div>,
            dataIndex: 'DatabaseName',
            width: 150,
            render: (text, record) => (
                <div style={{ textAlign: 'center', fontSize: 11 }}>
                    <b>{record.DatabaseName}</b>
                </div>

            ),
        },
        {
            title: <div style={{ textAlign: "center", fontSize: 12 }}>
                Ngày hết hạn/Trạng thái
            </div>,
            dataIndex: 'Active',
            width: 180,
            sorter: (a, b) => a.Active - b.Active,

            render: (text, record) => (
                <div>
                    <Row style={{ textAlign: 'center', fontSize: 11 }}>
                        <Col span={24}>
                            <b>{moment(record.ExpirationDate).format('DD-MM-YYYY HH:mm')}</b>
                        </Col>
                        <Col span={24}>
                            <Tag color={record.Active === true ? 'geekblue' : 'purple'}>{record.Active === true ? 'Kích hoạt' : 'Chưa kích hoạt'}</Tag>
                        </Col>
                    </Row>

                </div>

            ),
        },

    ]

    const handleOk = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpenModalAccount(false);
        }, 3000);
    }
    const resetForm = () => {
        formAccount.resetFields()
    }
    const handleCancel = () => {
        resetForm();
        setLoading(false);
        setOpenModalAccount(false);
    }
    const checkFilter = (values) => {
        // kiểm tra tham số truyền vào khi lọc tìm kiếm
        var InfoUser = values.InfoUser;
        var RoleFilter = values.RoleFilter;
        var result = 0;
        if (values.InfoUser === undefined) {
            InfoUser = "";
        }
        if (values.RoleFilter === undefined) {
            RoleFilter = "default";
        }
        // console.log(`InfoUser : ${InfoUser} và RoleFilter : ${RoleFilter}`);

        // trường hợp chỉ nhập Infouser trả về status filter = 1
        if (InfoUser !== "" && RoleFilter === "default") {
            result = 1;
        }
        if (InfoUser === "" && RoleFilter !== "default") {
            result = 2;
        }
        if (InfoUser !== "" && RoleFilter !== "default") {
            result = 3;
        }
        if (InfoUser === "" && RoleFilter === "default") {
            result = 4;
        }
        return result;
    };
    const onFinishFilter = (values) => {
        // lọc tìm kiếm
        if (checkFilter(values) === 1) {
            axiosClient
                .post('/Accounts/SubGetAccountsAll', user, {
                    headers: header,
                })
                .then((res) => {
                    setDataAccount(
                        res.data.filter(
                            (i) =>
                                i.UserName === values.InfoUser ||
                                i.FullName === values.InfoUser ||
                                i.Phone === values.InfoUser ||
                                i.Email === values.InfoUser ||
                                i.DatabaseName === values.InfoUser
                        )
                    );
                });
        }
        if (checkFilter(values) === 2) {
            axiosClient
                .post('/Accounts/SubGetAccountsAll', user, {
                    headers: header,
                })
                .then((res) => {
                    setDataAccount(res.data.filter((i) => i.Role === values.RoleFilter));
                });
        }
        if (checkFilter(values) === 3) {
            axiosClient
                .post('/Accounts/SubGetAccountsAll', user, {
                    headers: header,
                })
                .then((res) => {
                    setDataAccount(
                        res.data.filter(
                            (i) =>
                                (i.UserName === values.InfoUser ||
                                    i.FullName === values.InfoUser ||
                                    i.Phone === values.InfoUser ||
                                    i.Email === values.InfoUser ||
                                    i.DatabaseName === values.InfoUser) &&
                                i.Role === values.RoleFilter
                        )
                    );
                });
        }
        if (checkFilter(values) === 4) {
            loadDataAccount()
        }
    }
    const onFinishAccount = (values) => {
        setLoading(true)
        const currentData = dataAccount.filter(i => i.ID === values.ID);
        if (statusModalAccount === false) {
            if (validateAdd(values) === 1) {
                axiosClient
                    .post('/PartnerAccounts/CreatePartnerManagerAccount', {

                        "account": {
                            ID: values.ID,
                            Role: values.Role,
                            FullName: values.FullName,
                            UserName: values.UserName,
                            Password: values.Password,
                            Phone: values.Phone,
                            Email: values.Email,
                            Image: values.Image,
                            Active: values.Active,
                            DatabaseName: database,
                            SecurityCode: values.SecurityCode,
                            ExpirationDate: values.ExpirationDate,
                        },
                        "IDPartner": values.IDPartner
                    }, {
                        headers: header,
                    })
                    .then((res) => {
                        if (res.status === 200) {
                            swal("Thêm thành công!!!", {
                                icon: "success",
                            });
                            loadDataAccount()
                            setOpenModalAccount(false);
                            setLoading(false);
                        }
                    });
            } else {
                setOpenModalAccount(true);
            }
        } else {
            if (values.Password === currentData[0].Password) {
                axiosClient
                    .post(
                        '/Accounts/SubUpdateAccounts',
                        {
                            ID: values.ID,
                            Role: values.Role,
                            FullName: values.FullName,
                            UserName: values.UserName,
                            Password: values.Password,
                            Phone: values.Phone,
                            Email: values.Email,
                            Image: values.Image,
                            Active: values.Active,
                            DatabaseName: database,
                            SecurityCode: values.SecurityCode,
                            ExpirationDate: values.ExpirationDate,
                            "IDSoftware": values.IDPartner,

                        },
                        {
                            headers: header,
                        }
                    )
                    .then((res) => {
                        if (res.status === 200) {
                            swal("Cập nhật thành công!!!", {
                                icon: "success",
                            });
                            loadDataAccount()
                            setOpenModalAccount(false);
                            setLoading(false);
                        }
                    });
            } else {
                axiosClient
                    .post(
                        '/Accounts/ChangePassword',
                        {
                            ID: values.ID,
                            Role: values.Role,
                            FullName: values.FullName,
                            UserName: values.UserName,
                            Password: values.Password,
                            Phone: values.Phone,
                            Email: values.Email,
                            Image: values.Image,
                            Active: values.Active,
                            DatabaseName: database,
                            SecurityCode: values.SecurityCode,
                            ExpirationDate: values.ExpirationDate,
                            "IDSoftware": values.IDPartner,

                        },
                        {
                            headers: header,
                        }
                    )
                    .then((res) => {
                        if (res.status === 200) {
                            swal("Cập nhật thành công!!!", {
                                icon: "success",
                            });

                            loadDataAccount()
                            setOpenModalAccount(false);
                            setLoading(false);
                        }
                    });
            }
        }
    }
    const handleDelete = (record) => {

        setLoading(true)
        if (record.ID !== 0) {
            swal({
                title: "Bạn có muốn xóa tài khoản này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/CompanyAccount/DeleteCompanyAccount`, {
                            "ID": 1,
                            "IDAccount": record.ID,
                            "IDCompany": record.IDCompany
                        }, { headers: header }).then(res => {
                            if (typeof res.data !== 'string') {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                loadDataAccount();
                                setLoading(false)
                            }
                            else {
                                swal(res.data, {
                                    icon: 'error'
                                });
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const showModalPartner = (record) => {
        //const IDTemp = 0;

        resetForm();
        if (record === 0) {
            // thêm mới

            setFileList([])
            setStatusModalAccount(false);
            setOpenModalAccount(true);
        }
        else {

            // cập nhật
            setStatusModalAccount(true);
            setOpenModalAccount(true);
            const data = dataAccount.filter(i => i.ID === record);
            const arrImageTour = String(data.map(r => r.Image)).split(';');
            fillArrayImage(arrImageTour);
            formAccount.setFieldsValue({
                Image: data[0].Image,
                FullName: data[0].FullName,
                UserName: data[0].UserName,
                Password: data[0].Password,
                Phone: data[0].Phone,
                Email: data[0].Email,
                Active: data[0].Active,
                Role: data[0].Role,
                DatabaseName: data[0].DatabaseName,
                SecurityCode: data[0].SecurityCode,
                ExpirationDate: moment(data[0].ExpirationDate),
                ID: data[0].ID,
            })


        }
    }
    const validateAdd = (param) => {
        const dataJson = JSON.stringify(dataAccount);
        if (dataJson.includes(param["FullName"])) {
            swal(`Tên nhân viên :[${param["FullName"]}] đã tồn tại!!!`, {
                buttons: false,
                icon: "warning",
            });
            setLoading(false)
            return 0;
        }
        if (dataJson.includes(param["UserName"])) {
            swal(`Tên đăng nhập :[${param["UserName"]}] đã tồn tại!!!`, {
                buttons: false,
                icon: "warning",
            });
            setLoading(false)
            return 0;
        }
        if (dataJson.includes(param["Email"])) {
            swal(`Email: [${param["Email"]}] đã tồn tại!!!`, {
                buttons: false,
                icon: "warning",
            });
            setLoading(false)
            return 0;
        }
        if (dataJson.includes(param["Phone"])) {
            swal(`Số điện thoại : [${param["Phone"]}] đã tồn tại!!!`, {
                buttons: false,
                icon: "warning",
            });
            setLoading(false)
            return 0;
        } else {
            setLoading(false)
            return 1;
        }
    };
    const fillArrayImage = (arr) => {
        const list = []
        arr.map(r => (
            toDataURL(r)
                .then(dataUrl => {
                    var fileData = dataURLtoFile(dataUrl, r.split('http://mqcomputer.ddns.net:8080/files/')[1]);
                    list.push({
                        lastModified: fileData.lastModified,
                        name: fileData.name,
                        status: 'done',
                        url: r,
                        uid: `__AUTO__1694415727047_${Math.floor(Math.random() * 101)}__`,
                    });

                })
        ))
        setFileList(list);
    }
    const renderAccount = () => {
        return (
            <Form
                id="form-Account"
                form={formAccount}
                onFinish={onFinishAccount}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>
                <Row>
                    <Col span={24}>
                        <Form.Item label="Upload hình ảnh">
                            {/* upload hình ảnh */}
                            <Upload
                                accept="image/png,image/jpeg"
                                customRequest={uploadImage}
                                listType="picture-card"
                                fileList={fileList}
                                onPreview={previewUpload}
                                onChange={changeUpload}
                                maxCount={1}
                            >
                                {fileList.length > 1 ? null : <div>Choose file Upload</div>}
                                <Modal visible={previewVisible} footer={null} onCancel={cancelUpload}>
                                    <img style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                            </Upload>
                        </Form.Item>
                        <Form.Item label="URL hình ảnh" name={"Image"}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập tên nhân viên",
                                },
                            ]}
                            label="Tên nhân viên"
                            name={"FullName"}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Tên đăng nhập"
                            name="UserName"
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập tài khoản đăng nhập",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập mật mã",
                                },
                            ]}
                            label="Mật khẩu"
                            name={"Password"}
                        >
                            {statusModalAccount === false ? <Input.Password /> : <Input type="password" />}
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập số điện thoại",
                                    pattern: new RegExp(/^[0-9]+$/),
                                },
                            ]}
                            label="Phone"
                            name={"Phone"}
                        >
                            <Input maxLength={11} />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập email",
                                    type: "email",
                                },
                            ]}
                            label="Email"
                            name={"Email"}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Phân quyền"
                            name={"Role"}
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng chọn quyền",
                                },
                            ]}
                        >
                            {String(role).toLowerCase() === 'admin' ?
                                <Select onSelect={selectRole} placeholder="Chọn quyền">
                                    <Option value={"manager"}>Manager</Option>
                                    <Option value={"user"}>User</Option>
                                </Select>
                                : <Select onSelect={selectRole} placeholder="Chọn quyền">
                                    <Option value={"user"}>User</Option>
                                </Select>}
                        </Form.Item>
                        <Form.Item
                            label="Đối tác"
                            name={"IDCompany"}
                            rules={[
                                {
                                    required: roleStatus === 'user' ? true : false,
                                    message: "Vui lòng chọn Đối tác",
                                },
                            ]}
                        >
                            <Select>
                                {dataPartners.map(r => (
                                    <Option value={r.ID}>
                                        {r.PartnerName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={0}>
                        <div className="clearfix" style={{ height: 135 }}></div>
                        <Form.Item hidden
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng nhập mã bảo mật",
                                },
                            ]}
                            label="Mã bảo mật"
                            name={"SecurityCode"}
                        >
                            {statusModalAccount === false ? <Input.Password /> : <Input type="password" />}
                        </Form.Item>


                        <Form.Item hidden
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng chọn ngày hết hạn",
                                },
                            ]}
                            label="Ngày hết hạn"
                            name={"ExpirationDate"}
                        >
                            <DatePicker
                                disabledDate={(current) => {
                                    let customDate = moment().format("DD-MM-YYYY");
                                    return current && current < moment(customDate, "DD-MM-YYYY");
                                }}

                                suffixIcon={null}
                                style={{ width: '100%' }}
                                format={"DD-MM-YYYY"}
                            />
                        </Form.Item>
                        <Form.Item hidden
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng chọn trạng thái",
                                },
                            ]}
                            label="Trạng thái"
                            name={"Active"}
                        >
                            <Select style={{ width: 200 }} placeholder="Chọn trạng thái">
                                <Option value={false}>Không kích hoạt</Option>
                                <Option value={true}>Kích hoạt</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }
    return (
        <div>
            <Card size="small"  >
                <Tabs type="card" tabBarStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Tabs.TabPane tab='Thông tin đối tác' key={1}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form
                                    form={formFilterAccount}
                                    name="basic"
                                    id="form-filter-account"
                                    onFinish={onFinishFilter}
                                    labelCol={{ span: 0 }}
                                    labelAlign="right"
                                    colon={false}
                                    wrapperCol={{
                                        span: 24,

                                    }}
                                >
                                    <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={15} span={16}>
                                            <Form.Item name="InfoUser">
                                                <AutoComplete style={{ width: "100%" }} placeholder="Thông tin đối tác" onSearch={suggestionSearch} dropdownMatchSelectWidth={252}>
                                                    {dataAccount
                                                        .filter((item) => {
                                                            const search = String(searchResult).toString();
                                                            const searchTerm = search.toLowerCase();
                                                            const fullName = item.FullName.toLowerCase();
                                                            const databaseName = item.DatabaseName.toLowerCase();
                                                            const phone = item.Phone;
                                                            const username = item.UserName.toLowerCase();
                                                            const Email = item.Email.toLowerCase();
                                                            return (
                                                                searchTerm &&
                                                                (fullName.startsWith(searchTerm) ||
                                                                    phone.startsWith(searchTerm) ||
                                                                    username.startsWith(searchTerm) ||
                                                                    databaseName.startsWith(searchTerm) ||
                                                                    Email.startsWith(searchTerm)) &&
                                                                (searchTerm !== fullName || searchTerm !== phone || searchTerm !== username || searchTerm !== Email || searchTerm !== databaseName)
                                                            );
                                                        })
                                                        .slice(0, 5)
                                                        .map((i, index) => (
                                                            <Option key={index} value={i.FullName}>
                                                                {`Tên nhân viên : ${i.FullName} -- Tên đăng nhập: ${i.UserName} -- Email:${i.Email} -- SĐT: ${i.Phone} -- DataBaseName: ${i.DatabaseName}`}
                                                            </Option>
                                                        ))}
                                                </AutoComplete>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={4} span={4}>
                                            <Form.Item name="RoleFilter">
                                                <Select defaultValue={"Chọn quyền"}>
                                                    <Option value={"default"}>Chọn quyền</Option>
                                                    <Option value={"system"}>System</Option>
                                                    <Option value={"admin"}>Admin</Option>
                                                    <Option value={"manager"}>Manager</Option>
                                                    <Option value={"user"}>User</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={5} span={3}>
                                            <Form.Item>
                                                <Button.Group>
                                                    <Button icon={<SearchOutlined />} form="form-filter-account" htmlType="submit" type="primary" style={{ backgroundColor: '#22B14C', color: 'white', borderRadius: 4 }} >Lọc</Button>
                                                    &nbsp;
                                                    <Button icon={<PlusOutlined />} type="primary" onClick={(e => showModalPartner(0))} style={{ borderRadius: 4 }} >Thêm mới</Button>
                                                </Button.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="clearfix"></div>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} sticky columns={columnsAccount} dataSource={dataAccount} />
                            </Col>
                        </Row>

                    </Tabs.TabPane>

                </Tabs>
            </Card>
            <Modal
                width={1000}
                open={openModalAccount}
                title={
                    <span>
                        {statusModalAccount === false ? 'Thêm mới tài khoản' : 'Cập nhật tài khoản'}
                    </span>
                }
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Hủy
                    </Button>,
                    <Button form="form-Account" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderAccount()}</>
                )}
            </Modal>

        </div>
    )
}
export default AdminPage;